import { useState } from "react";
import { publishSuccessTunnel } from "../../constants/tunnels";
import { trackWithAttribution, Events } from "../../utils/analytics";

export default function PublishSuccessModal({ publishedUrl, roomId, onExit, onClose }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(publishedUrl);
      setCopied(true);
      trackWithAttribution(Events.SHARE_LINK_COPIED, { roomId, method: 'clipboard' });
      // Reset after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleExit = () => {
    onClose();
    onExit();
  };

  return (
    <publishSuccessTunnel.In>
      <div
        style={{
          width: "80vw",
          maxWidth: "500px",
          transform: "translate(-50%, -50%)",
          zIndex: 10000000,
          top: "50%",
          left: "50%",
          position: "absolute",
          background: "white",
          border: "3px solid #000000",
          padding: "20px 30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
          fontFamily: "DM Mono, monospace",
          fontSize: "24px",
        }}
      >
        <p>Room Published!</p>
        <p
          style={{
            fontSize: "14px",
            color: "#666",
            margin: "8px 0 0 0",
            lineHeight: "1.4",
          }}
        >
          Some rooms go to manual review and have a short delay publishing.
          Contact @Mogulplex on Instagram if you have any questions.
        </p>
        <div
          style={{
            marginTop: "15px",
            fontSize: "20px",
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <button
            onClick={handleExit}
            style={{
              padding: "6px 12px",
              backgroundColor: "#26EF96",
              color: "black",
              border: "none",
              cursor: "pointer",
              flex: 1,
              minWidth: "fit-content",
            }}
          >
            Exit
          </button>
          <button
            onClick={handleShare}
            style={{
              border: "3px solid #000000",
              padding: "6px 12px",
              cursor: "pointer",
              flex: 1,
              minWidth: "fit-content",
              backgroundColor: copied ? "#26EF96" : "white",
              transition: "background-color 0.2s",
            }}
          >
            {copied ? "Copied!" : "Share"}
          </button>
        </div>
      </div>
    </publishSuccessTunnel.In>
  );
}
